<div class="sol-select-content">
  @if (searchable$() || showClear$()) {
    <div class="sol-select-content-toolbar">
      @if (searchable$()) {
        <sol-search-field
          [value]="searchText$()"
          [loading]="loading$()"
          [debounce]="debounce$()"
          (value)="onSearch($event)"
          #searchRef
        />
      }
      @if (showClear$()) {
        <sol-button text="sol-common.clear" [type]="SolButtonType.transparent" (click)="onClear()" />
      }
    </div>
  }
  <div class="sol-select-content-results">
    @if (hasResults$()) {
      <div
        class="sol-select-content-list"
        role="listbox"
        [attr.id]="listboxId$()"
        [attr.aria-multiselectable]="multi$() || null"
      >
        @for (item of items$(); track item.id) {
          <div
            class="sol-select-content-item"
            role="option"
            [attr.id]="item.optionId"
            [attr.aria-selected]="item.selected"
            [attr.aria-disabled]="item.disabled || null"
            [class.sol-select-content-item-active]="item.active"
            [class.sol-select-content-item-disabled]="item.disabled"
            [class.sol-select-content-item-selected]="item.selected"
            (click)="onSelect(item)"
          >
            @if (item.showCheckbox) {
              <div class="sol-select-content-item-checkbox">
                <sol-checkbox [selected]="item.selected"></sol-checkbox>
              </div>
            }
            @if (item.infoBelow) {
              <div class="sol-select-content-item-details">
                <sol-view class="sol-select-content-item-name" [data]="item.viewData" />
                <div class="sol-select-content-item-description">{{ item.info | translate }}</div>
              </div>
            } @else {
              <sol-view class="sol-select-content-item-name" [data]="item.viewData"></sol-view>
              @if (item.info) {
                <div class="sol-select-content-item-info">
                  {{ item.info | translate }}
                </div>
              }
            }
          </div>
        }
      </div>
    } @else {
      <div class="sol-select-content-empty">
        {{ 'sol-select.empty' | translate }}
      </div>
    }
  </div>
  @if (footerMenu$().length > 0) {
    <div class="sol-select-content-menu">
      <sol-popover-menu-content [menu]="footerMenu$()" (action)="onMenuAction($event)" />
    </div>
  }
</div>
